<div class="sidebar" [ngClass]="{ 'expanded': isExpanded }">
  <div class="header-sidebar">
    <img src="./assets/images/logo-bo-new-gen.png" alt="" height="40" width="136">
  </div>
  <div class="content" *ngFor="let i of listMenu">
    <div *ngFor="let item of i.children">
      <div *ngIf="item.children.length == 0" class="link">
        <div class="content" (mouseover)="setHovered(item.route,true)" (mouseout)="setHovered(item.route,false)"
          (click)="activeTab(item.route)" [class.active]="checkActiveTab('main',item)">
          <div class="icon">
            <img *ngIf="!this.openMenus[item.route]" class="icon-menu" [src]="item.iconDefault" alt="" height="16"
              width="16">
            <img *ngIf="this.openMenus[item.route]" class="icon-menu" [src]="item.iconActive" alt="" height="16"
              width="16">
          </div>
          <div class="title">{{item.title}}</div>
        </div>
      </div>
    </div>
  </div>
  <!-- Add Version Number -->
  <div class="footer-version">
    Version: 1.0.1
  </div>
</div>

<div class="sidebar-m" [ngClass]="{ 'expanded': isExpanded }" [ngStyle]="{'display': isExpanded ? 'inline-block': 'none'}">
  <div class="header-sidebar">
    <img src="./assets/images/logo-bo-new-gen.png" alt="" height="40" width="136">
  </div>
  <div class="content" *ngFor="let i of listMenu">
    <div *ngFor="let item of i.children">
      <div *ngIf="item.children.length == 0" class="link">
        <div class="content" (mouseover)="setHovered(item.route,true)" (mouseout)="setHovered(item.route,false)"
          (click)="activeTab(item.route)" [class.active]="checkActiveTab('main',item)">
          <div class="icon">
            <img *ngIf="!this.openMenus[item.route]" class="icon-menu" [src]="item.iconDefault" alt="" height="16"
              width="16">
            <img *ngIf="this.openMenus[item.route]" class="icon-menu" [src]="item.iconActive" alt="" height="16"
              width="16">
          </div>
          <div class="title">{{item.title}}</div>
        </div>
      </div>
    </div>
  </div>
  <!-- Add Version Number -->
  <div class="footer-version">
    Version: 1.0.1
  </div>
</div>
